/* eslint-disable */
import React, { useState, useEffect } from "react";
import GraphBar from "./graph-bar";
import Tooltip from "./tooltip-graph";
import themePropTypes from "../theme-prop-types";

const GraphColumn = ({
  width,
  height,
  dayData,
  showGrid,
  calculateBarHeight
}) => {
  const [barsData, setBarsData] = useState([0, 0]);
  useEffect(() => {
    if (dayData) {
      setBarsData([
        parseInt(dayData?.value[1]) * 60,
        parseInt(dayData?.value[0]) * 60
      ]);
    } else {
      setBarsData([0, 0]);
    }
  }, [dayData]);

  return (
    <div
      className='graph-column-web-sdk'
      data-testid='graph-column-web-sdk'
      style={{
        width: `${width}px`,
        height: `${height}px`,
        borderStyle: `${showGrid ? "solid" : "none"}`
      }}
    >
      {barsData?.map((bar, index) => {
        return (
          <>
            <GraphBar
              showDivider={index == 1 ? (showGrid ? true : false) : false}
              barHeight={bar}
              color={
                index == 0 ? dayData?.value_color[0] : dayData?.value_color[1]
              }
              calculateBarHeight={calculateBarHeight}
              key={index}
            />
          </>
        );
      })}
      <Tooltip value={dayData?.aria_label} />
    </div>
  );
};

GraphColumn.propTypes = themePropTypes.graph;
export default GraphColumn;
